import request from "../../Requests/requests";
import { getCountPercentTask } from "../../store/StatisticsStore/TaskPercentCounterReducer";

export const getForecastAccurasy = (payload) => {
    return async dispatch => {
        await request.get('/Statistics/ForecastAccuracy/', {
            params: {UserId: localStorage.getItem('userID'),
            DateStart: payload.DateStart, 
            DateEnd: payload.DateEnd }
        })
        .then(response =>{
            const data = response.data;
            dispatch(getCountPercentTask(data.forecastAccuracyPercent))
        })
        
    }
}
